"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BreadcrumbListItem = _ref => {
  var {
    crumb,
    isLastItem,
    breadcrumbTrimPlaceholder
  } = _ref;
  if (crumb === breadcrumbTrimPlaceholder) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "breadcrumb-item"
    }, breadcrumbTrimPlaceholder);
  }
  if (isLastItem) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "breadcrumb-item active",
      "aria-current": "page"
    }, crumb.label);
  }
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "breadcrumb-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: crumb.targetLink
  }, crumb.label));
};
var _default = exports.default = BreadcrumbListItem;